import React__default from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const InfoIcon$1 = (props) => /* @__PURE__ */ React__default.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24" }, props), /* @__PURE__ */ React__default.createElement("g", { fill: props.backgroundColor, fillRule: "evenodd" }, /* @__PURE__ */ React__default.createElement(
  "path",
  {
    d: "M12.167 4c4.51 0 8.166 3.582 8.166 8s-3.656 8-8.166 8S4 16.418 4 12s3.656-8 8.167-8zm0 .889c-4.01 0-7.26 3.184-7.26 7.111 0 3.927 3.25 7.111 7.26 7.111 4.009 0 7.259-3.184 7.259-7.111 0-3.927-3.25-7.111-7.26-7.111zm.617 5.576v4.247l.509.025v.819H11.11v-.785l.198-.018c.184-.018.331-.155.365-.332l.007-.077c.002-.01.003-.091.004-.247v-.18l.001-.052v-.454-.508l-.005-1.346c-.001-.158-.07-.237-.208-.237h-.362v-.855h1.673zm-.764-2.91c.502 0 .91.408.91.91s-.408.909-.91.909-.909-.407-.909-.91c0-.501.407-.908.91-.908z",
    transform: "translate(-2058 -1176) translate(2058 1176)"
  }
)));

export { InfoIcon$1 as default };
//# sourceMappingURL=InfoIcon.js.map
